module.exports = __webpack_public_path__ + "img/logo_sei.a2972fba.png";